import { useMemo } from 'react'

import { getListingHelpers, PropSharingListing, StockAllowance } from '@guiker/propsharing-shared'

export const useGetHelpers = (listing: PropSharingListing, stockAllowance?: StockAllowance) => {
  return useMemo(() => getListingHelpers(listing, stockAllowance), [listing, stockAllowance])
}
